import { ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { throttle } from 'underscore';
import { IComment } from './Contract';

export const CHAT_LOAD_THROTTLE_TIME_MS = 250;

export class ChatDataSource {
	private readonly commentsSubject$ = new BehaviorSubject<IComment[]>([]);
	public comments$ = this.commentsSubject$.asObservable();
	public scrollWrapper: ElementRef<HTMLElement>;

	private readonly next = throttle((comments: IComment[]) => this.commentsSubject$.next(comments), CHAT_LOAD_THROTTLE_TIME_MS);

	public setComments(comments: IComment[]): void {
		this.commentsSubject$.next(comments);
	}

	public append(comment: IComment): void {
		const comments = this.commentsSubject$.getValue();
		comments.push(comment);
		this.next(comments);
	}

	public update(comment: IComment): void {
		const comments = this.commentsSubject$.getValue();
		const newComments = comments.map(c => c.id === comment.id ? { ...c, ...comment } : c);

		this.next(newComments);
	}
}
